import React from 'react'
import Applycompo from '../components/Applycompo'
import Applay from '../components/Applay'
import Processingcompo from '../components/Processingcompo'
import WhyChoose from '../components/WhyChoose'
import HowItWorks from '../components/HowItWorks'
import Empowering from '../components/Empowering'

const Home = () => {
  return (
    <>
      <Applycompo/>
      <Empowering/>
      <Applay/>
      <Processingcompo/>
      <WhyChoose/>
      <HowItWorks/>
      </>
  )
}

export default Home;